export default __webpack_public_path__ + "static/media/kazam-mini.c0dcb082.png";